import axios from "axios";
import authHeader from "./authHeader";
import { apiPath, API_URL, REACT_APP_REMOVE_BG_API_URL, REACT_APP_X_API_KEY, HOST_TYPE } from "./apiPath";
import { getStoredUser } from "../utils/storage";
import { getAccessToken, getLocalTimeZone } from "./commonService";
const currentUser = getStoredUser();
const API_KEY = "7gudoIDFkjmTcKFK6r4L396v0JeXCUIL";

export const removeBg = async (user_id, image_path, image_extension) => {
  let body = {
    worker_id: user_id,
    image_path: image_path,
    image_extension: image_extension,
    token: currentUser.token
  };
  const response = await axios
    .post(API_URL + apiPath.removeBg, body, authHeader());
  return response.data;
};

// Get pre-signed URL from backend
const getPresignedUrl = async (filesToUpload) => {
  try {
    let fileExtension = filesToUpload.file.name.substring(filesToUpload.file.name.lastIndexOf(".") + 1);
    let res = await axios.post(API_URL + apiPath.getSignedUrl, {
      file_extension: fileExtension,
      path: filesToUpload.folder,
      token: getAccessToken()
    }, {
      headers: {
        'x-api-key': REACT_APP_X_API_KEY,
        'hosttype': HOST_TYPE,
        'ip': localStorage.getItem('userIP'),
        'device': navigator.userAgent,
        'timezone': getLocalTimeZone()
      },
    });
    return res.data.data;
  } catch (error) {
    console.error("Error fetching presigned URL:", error);
  }
};

const uploadToS3File = async (processedImage, presignedUrl) => {
  if (!processedImage || !presignedUrl) {
    return { url: "", filename: "", status: false };
  }
  const response = await fetch(processedImage);
  const blob = await response.blob();
  try {
    await axios.put(presignedUrl, blob, {
      headers: {
        "Content-Type": "image/png",
        'x-api-key': REACT_APP_X_API_KEY,
        'timezone': getLocalTimeZone(),
        'device': navigator.userAgent,
        'ip': localStorage.getItem('userIP')
      },
    });
  } catch (error) {
    console.error("Error uploading to S3:", error);
  }
};

export const removeBackground = async (filesToUpload) => {
  const formData = new FormData();
  formData.append("file", filesToUpload.file);
  const response = await axios.post(REACT_APP_REMOVE_BG_API_URL + apiPath.removeBackground, formData, {
    headers: {
      "api-key": API_KEY,
      "Content-Type": "multipart/form-data",
    },
    responseType: "blob",
  });
  const imageUrl = URL.createObjectURL(response.data);
  let presignedUrl = await getPresignedUrl(filesToUpload);
  const url = presignedUrl.preview_file_url;
  const filePath = presignedUrl.filename;
  await uploadToS3File(imageUrl, presignedUrl.url);
  return { url: url, filename: filePath, status: true };
};

export const removeBackgroundFromURL = async (filesToUpload) => {
  const response = await axios.post(
    REACT_APP_REMOVE_BG_API_URL + apiPath.removeBackgroundFromURL + `?image_url=${ encodeURIComponent(filesToUpload.image_url) }`,
    {},
    {
      headers: {
        "api-key": API_KEY,
        "accept": "application/json",
      },
      responseType: "blob",
    }
  );
  const imageUrl = URL.createObjectURL(response.data);
  let presignedUrl = await getPresignedUrl(filesToUpload);
  const url = presignedUrl.preview_file_url;
  const filePath = presignedUrl.filename;
  await uploadToS3File(imageUrl, presignedUrl.url);
  return { url: url, filename: filePath, status: true };
};
